import { useId } from 'react';

export function PointMascot({ pose = 'peek', size = 120, flip = false, cubreOjos = false }) {
    const uid = useId().replace(/[:]/g, '');
    const clipId = `pclip-${uid}`;

    const remaches = [48, 62, 76, 90, 104, 118, 132, 146].map((x) => {
        const t = (x - 48) / 98;
        return { x, y: 52 - Math.sin(t * Math.PI) * 14 };
    });

    return (
        <div
            className={`mascota pose-${pose}`}
            style={{
                width: size,
                height: size * 1.3,
                transform: flip ? 'scaleX(-1)' : 'none',
                position: 'relative',
                display: 'inline-block',
            }}
        >
            <svg viewBox="0 0 200 260" width="100%" height="100%" style={{ overflow: 'visible' }}>
                <defs>
                    <clipPath id={clipId}>
                        <circle cx="100" cy="105" r="78" />
                    </clipPath>
                </defs>

                <g className="pierna pierna-i">
                    <path d="M84 172 Q80 200 78 214" stroke="#EB2A1B" strokeWidth="10" fill="none" strokeLinecap="round" />
                    <rect x="64" y="208" width="28" height="9" rx="4.5" fill="#e8eaf0" />
                    <path d="M60 216 h32 a8 8 0 0 1 8 8 v6 a8 8 0 0 1 -8 8 h-34 a10 10 0 0 1 -10 -10 c0 -7 5 -12 12 -12 z" fill="#2D3689" />
                    <rect x="66" y="222" width="22" height="3" rx="1.5" fill="#e8eaf0" />
                    <rect x="66" y="228" width="22" height="3" rx="1.5" fill="#e8eaf0" />
                </g>
                <g className="pierna pierna-d">
                    <path d="M116 172 Q120 200 122 214" stroke="#EB2A1B" strokeWidth="10" fill="none" strokeLinecap="round" />
                    <rect x="108" y="208" width="28" height="9" rx="4.5" fill="#e8eaf0" />
                    <path d="M108 216 h32 a10 10 0 0 1 10 10 c0 7 -5 12 -12 12 h-32 a8 8 0 0 1 -8 -8 v-6 a8 8 0 0 1 8 -8 z" fill="#2D3689" />
                    <rect x="112" y="222" width="22" height="3" rx="1.5" fill="#e8eaf0" />
                    <rect x="112" y="228" width="22" height="3" rx="1.5" fill="#e8eaf0" />
                </g>

                {!cubreOjos && pose === 'rest' && (
                    <>
                        <g className="brazo brazo-i">
                            <path d="M36 112 Q24 136 26 164" stroke="#EB2A1B" strokeWidth="9" fill="none" strokeLinecap="round" />
                            <rect x="17" y="160" width="20" height="8" rx="4" fill="#e8eaf0" transform="rotate(78 27 164)" />
                            <circle cx="27" cy="178" r="13" fill="#2D3689" />
                        </g>
                        <g className="brazo brazo-d">
                            <path d="M164 112 Q176 136 174 164" stroke="#EB2A1B" strokeWidth="9" fill="none" strokeLinecap="round" />
                            <rect x="163" y="160" width="20" height="8" rx="4" fill="#e8eaf0" transform="rotate(-78 173 164)" />
                            <circle cx="173" cy="178" r="13" fill="#2D3689" />
                        </g>
                    </>
                )}

                {!cubreOjos && pose !== 'redcard' && pose !== 'rest' && (
                    <>
                        <g className="brazo brazo-i">
                            <path d="M36 112 Q12 100 10 72" stroke="#EB2A1B" strokeWidth="9" fill="none" strokeLinecap="round" />
                            <rect x="0" y="62" width="22" height="8" rx="4" fill="#e8eaf0" transform="rotate(-14 11 66)" />
                            <circle cx="8" cy="48" r="13" fill="#2D3689" />
                            <circle cx="-1" cy="36" r="5.5" fill="#2D3689" />
                            <circle cx="14" cy="33" r="5" fill="#2D3689" />
                        </g>
                        <g className="brazo brazo-d">
                            <path d="M164 112 Q188 100 190 72" stroke="#EB2A1B" strokeWidth="9" fill="none" strokeLinecap="round" />
                            <rect x="178" y="62" width="22" height="8" rx="4" fill="#e8eaf0" transform="rotate(14 189 66)" />
                            <circle cx="192" cy="48" r="13" fill="#2D3689" />
                            <circle cx="201" cy="36" r="5.5" fill="#2D3689" />
                            <circle cx="186" cy="33" r="5" fill="#2D3689" />
                        </g>
                    </>
                )}

                {pose === 'redcard' && !cubreOjos && (
                    <>
                        <g className="brazo brazo-i">
                            <path d="M36 112 Q24 130 22 148" stroke="#EB2A1B" strokeWidth="9" fill="none" strokeLinecap="round" />
                            <circle cx="19" cy="160" r="13" fill="#2D3689" />
                        </g>
                        <g className="brazo brazo-d redcard-arm">
                            <path d="M164 112 Q186 90 192 60" stroke="#EB2A1B" strokeWidth="9" fill="none" strokeLinecap="round" />
                            <circle cx="192" cy="48" r="13" fill="#2D3689" />
                            <rect x="196" y="18" width="22" height="30" rx="3" fill="#EB2A1B" stroke="#c0180a" strokeWidth="1.5" />
                        </g>
                    </>
                )}

                <g className="cuerpo">
                    <circle cx="100" cy="105" r="78" fill="#2D3689" />
                    <rect x="20" y="156" width="160" height="40" fill="#EB2A1B" clipPath={`url(#${clipId})`} />
                    <ellipse cx="66" cy="52" rx="26" ry="12" fill="#ffffff" opacity="0.22" transform="rotate(-22 66 52)" />
                    <path d="M44 54 Q100 26 156 54" stroke="#1a255e" strokeWidth="3" fill="none" />
                    {remaches.map((r, i) => (
                        <circle key={i} cx={r.x} cy={r.y} r="2.6" fill="#d9dde6" />
                    ))}
                    <rect x="34" y="58" width="132" height="76" rx="38" fill="#EB2A1B" stroke="#d6dae2" strokeWidth="7" />
                    <ellipse className="mascota-eye mascota-eye-left" cx="74" cy="94" rx="8.5" ry="11" fill="#0c0c0c" />
                    <circle cx="77" cy="89" r="2.6" fill="#ffffff" />
                    <ellipse className="mascota-eye mascota-eye-right" cx="126" cy="94" rx="8.5" ry="11" fill="#0c0c0c" />
                    <circle cx="129" cy="89" r="2.6" fill="#ffffff" />
                    <g fill="#3fd9ff">
                        {[
                            [72, 6], [78, 11], [84, 7], [90, 15], [96, 10],
                            [102, 16], [108, 9], [114, 13], [120, 6], [126, 10],
                        ].map(([x, h], i) => (
                            <rect key={i} x={x} y={150 - h / 2} width="3" height={h} rx="1.5" />
                        ))}
                    </g>

                    {cubreOjos && (
                        <g>
                            <path d="M36 112 Q28 72 56 86" stroke="#EB2A1B" strokeWidth="9" fill="none" strokeLinecap="round" />
                            <path d="M164 112 Q172 72 144 86" stroke="#EB2A1B" strokeWidth="9" fill="none" strokeLinecap="round" />
                            <circle cx="74" cy="93" r="16" fill="#2D3689" stroke="#1a255e" strokeWidth="2" />
                            <circle cx="64" cy="82" r="5.5" fill="#2D3689" />
                            <circle cx="74" cy="78" r="5.5" fill="#2D3689" />
                            <circle cx="84" cy="81" r="5.5" fill="#2D3689" />
                            <circle cx="126" cy="93" r="16" fill="#2D3689" stroke="#1a255e" strokeWidth="2" />
                            <circle cx="116" cy="81" r="5.5" fill="#2D3689" />
                            <circle cx="126" cy="78" r="5.5" fill="#2D3689" />
                            <circle cx="136" cy="82" r="5.5" fill="#2D3689" />
                        </g>
                    )}
                </g>
            </svg>
        </div>
    );
}

export default PointMascot;
